export default __webpack_public_path__ + "static/media/prev-btn.bd8b795a.svg";